export default "__VITE_ASSET__s$c6XMVM__"